module.exports = __webpack_public_path__ + "static/Zeugnisprozess_Release_3-9db918da62faf8352310e650c926bd3a.pdf";